// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import styles from './faq_section.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import Icon_chevron_down
    from '../../../../hola/pub/img/svg/icon/chevron_down.svg';
import {Link, useHistory} from 'react-router-dom';
import hola_opt from 'hola_opt';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';

interface i_faq_quest_props {
    quest: string;
    ans: string | JSX.Element | Array<{name: string, url: string}>;
    blue_style?: boolean;
    transparent_style?: boolean;
    location_style?: boolean;
    is_continent?: boolean;
    link?: string;
    blue_bg_hover?: boolean;
}

export const Faq_question = (props: i_faq_quest_props)=>{
    const {theme} = useContext(Settings_context);
    const [opened, set_opened] = useState(false);
    const history = useHistory();
    const on_click = e=>{
        if (!props?.link)
            set_opened(!opened);
        else if (props?.link)
        {
            handle_click(e);
            history.push(props.link);
        }
        else return;
    };
    const continent_url =
        `/proxy-location/${props.quest.toLowerCase().replace(/\s+/g, '-')}`;
    const handle_click = e=>{
        e.stopPropagation();
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    const {t, T} = use_translation_v({no_defaults: true});
    const renderAnswer = ()=>{
        if (typeof props.ans==='string')
        {
            return <div className={styles.dangerous}
              dangerouslySetInnerHTML={{__html: t(props.ans)}}
            />;
        }
        else if (Array.isArray(props.ans))
        {
            return <div className={styles.country_list}>
              {props.ans.map(country=>
                <Link
                  key={country.name}
                  to={country.url}
                  className={cn(styles.country_link, theme.p14, theme.P)}
                  onClick={handle_click}>
                  <T>{country.name}</T>
                </Link>
              )}
            </div>;
        }
        else if (React.isValidElement(props.ans))
            return <T>{props.ans}</T>;
        else if (typeof props.ans==='object')
        {
            return <div className={cn(styles.dangerous)}>
              <T>{JSON.stringify(props.ans)}</T>
            </div>;
        }
        return null;
    };
    return <div className={cn(styles.faq_item, opened && styles.opened,
      props.blue_style && styles.blue_style,
      props.blue_bg_hover && styles.blue_bg_hover,
      props.transparent_style && styles.transparent_style,
      props.location_style && styles.location_style)}
      onClick={on_click}>
      <div className={styles.title_line}>
        <p className={cn(styles.p18, theme.med)}>
          {props.is_continent && opened ?
            <Link to={continent_url} onClick={handle_click}>
              {props.quest}
            </Link>
            : props?.link ?
            <Link to={props.link} onClick={handle_click}>
              {props.quest}
            </Link> :
            props.quest
          }
        </p>
          {!props?.link && <Icon_chevron_down />}
      </div>
      <div className={styles.faq_text}>
        {renderAnswer()}
      </div>
    </div>;
};

interface i_faq_section_props {
    color?: 'default' | 'transparent';
    title?: string;
    no_title?: boolean;
    custom_questions?: Array<{
        quest: string,
        ans: JSX.Element | Array<{
            name: string,
            url: string
        }>
    }>;
}

export const Faq_section = (props: i_faq_section_props)=>{
    const {no_title, title, custom_questions,
        color = 'default'} = props;
    const {t, T} = use_translation_v({no_defaults: true});
    const questions = custom_questions ||
        (hola_opt.intercom_articles?.default || []).map(article=>({
            quest: article.title,
            ans: article.body
        }));
    return <div className={cn(styles.faq, styles[color])}>
        {!no_title && <h2><T>{title || 'Some FAQs'}</T></h2>}
        {questions.map((question, index)=>
          <Faq_question
            key={index}
            quest={t(question.quest)}
            ans={question.ans}
            is_continent={Array.isArray(question.ans)}/>
        )}
      </div>;
};
